import { EcosystemEnum } from "@clockwise/schema";
import { appPaths } from "@clockwise/web-commons/src/constants/route.constants";
import { NavContext, SidebarTabs } from "@clockwise/web-commons/src/ui/home-nav/home-nav";
import { useEcosystem } from "@clockwise/web-commons/src/util/ecosystem";
import classNames from "classnames";
import { useRouter } from "found";
import React, { useContext } from "react";
import { useOnboarding } from "../../hooks/useOnboarding/useOnboarding";
import { useFeatureFlag } from "../../launch-darkly";
import { canAccessExperiments } from "../../util/auth.util";
import { AIModalWebapp } from "../web-app-calendar/AIModalWebapp";

export const WebNavigation = () => {
  const [showClockwiseAI] = useFeatureFlag("ClockwiseAI");
  const [isM365TeamAvailabilityCalendarExperimentOn] = useFeatureFlag(
    "M365TeamAvailabilityCalendar",
  );
  const ecosystem = useEcosystem();
  const { match } = useRouter();
  const hideM365Teams =
    ecosystem === EcosystemEnum.Microsoft && !isM365TeamAvailabilityCalendarExperimentOn;

  const { collapsed } = useContext(NavContext);
  const { shouldShowNUXChecklist } = useOnboarding();
  const sidebarClasses = "cw-flex-shrink-0 cw-h-auto";
  const sidebarOpenClasses = `cw-w-full cw-max-w-[270px] cw-transition cw-ease-in-out cw-overflow-x-hidden`;
  const sidebarClosedClasses = "cw-w-[72px] cw-transition cw-ease-in-out cw-overflow-x-hidden";

  const isOnAIPage =
    match.location.pathname === appPaths.ai || match.location.pathname === appPaths.aiScheduler;
  const maybeShowAIModal = !isOnAIPage && showClockwiseAI;
  AIModalWebapp;
  return (
    <div
      className={classNames("cw-block", "cw-top-20 cw-static cw-bg-nav", sidebarClasses, {
        [sidebarOpenClasses]: !collapsed,
        [sidebarClosedClasses]: collapsed,
      })}
    >
      {maybeShowAIModal && <AIModalWebapp />}
      <SidebarTabs
        showExperiments={canAccessExperiments()}
        shouldShowGetStartedLandingPage={shouldShowNUXChecklist}
        showAI={showClockwiseAI}
        hideM365Teams={hideM365Teams}
      />
    </div>
  );
};
